import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { ExploreRoutingModule } from "./explore-routing.module";
import { ExplorePageComponent } from "./components/explore-page/explore-page.component";
import { GridsterModule } from "angular2gridster";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthCamerallaInterceptor } from "../../auth/interceptors/auth.interceptor";
import { ErrorCamerallaInterceptor } from "../../auth/interceptors/error.interceptor";
import { ViewExplorePhotoComponent } from "./components/view-explore-photo/view-explore-photo.component";
import { ManageAdsBannerPhotoComponent } from "./components/ads-banner-photo/manage-ads-banner-photo.component";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CoreModule,
        SharedModule,
        GridsterModule.forRoot(),
        ExploreRoutingModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthCamerallaInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorCamerallaInterceptor,
            multi: true
        }
    ],
    entryComponents: [ExplorePageComponent, ViewExplorePhotoComponent, ManageAdsBannerPhotoComponent],
    declarations: [ExplorePageComponent, ViewExplorePhotoComponent, ManageAdsBannerPhotoComponent],
    exports: [ExplorePageComponent]
})
export class ExploreModule {
}
